import { FieldInputProps, useField, useFormikContext } from "formik";
import React from "react";

import { FieldStateProps } from "../FieldHeader";
import { TextField } from "../TextField";
import { useSetFieldTouched } from "../useSetFieldTouched";

type PhoneInputFieldProps = Readonly<{
  name: string;
  title: string;
  type?: "number" | "string";
  isRequiredField?: boolean;
}> &
  FieldStateProps;

export const PhoneInputField = (props: PhoneInputFieldProps) => {
  const { name, title, type, disabled, isSaving, isRequiredField } = props;

  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);

  useSetFieldTouched(field.name);

  const phoneAcceptedValues = (
    e: React.ChangeEvent<HTMLInputElement>,
    // eslint-disable-next-line
    field: FieldInputProps<any>
  ) => {
    const phoneNumberRegex = /[^0-9.\-()+]/g;
    const targetValue = e.target.value;
    const rawNumber = targetValue.replace(/\D/g, "");
    let inputFormattedValue;
    if (rawNumber.length > 13) {
      inputFormattedValue = targetValue.slice(0, -1).replace(phoneNumberRegex, "");
    } else {
      inputFormattedValue = targetValue.replace(phoneNumberRegex, "");
    }
    setFieldValue(field.name, inputFormattedValue);
    return field.onChange;
  };

  return (
    <TextField
      name={name}
      title={title}
      type={type}
      isRequiredField={isRequiredField}
      disabled={disabled}
      isSaving={isSaving}
      customOnChange={phoneAcceptedValues}
    />
  );
};
